import { agentApiPath } from "constants/defaultValues";
import { put, takeEvery } from "redux-saga/effects";
import { bearerReq } from "services/requests.services";

function* ledgerFunc(action) {
  const { id, payload } = action;

  try {
    const data = yield bearerReq("POST", `${agentApiPath}/addLedger/${id}`, payload);

    yield put({
      type: "LEDGER_CREATE_SUCCESS",
      data: data.data
    });
    yield put({
      type: "LEDGER_HISTORY",
      id: action?.complaintId
    });
  } catch (error) {
    yield put({
      type: "LEDGER_CREATE_FAILED",
      message: "Failed to create ledger !!"
    });
  }
}

function* ledgerUpdateFunc(action) {
  const { ledgerId, id, payload } = action;
  try {
    const data = yield bearerReq("PUT", `${agentApiPath}/updateLedger/${ledgerId}`, payload);
    if (data?.success) {
      yield put({
        type: "LEDGER_UPDATE_SUCCESS",
        data: data.data,
        message: data?.message
      });

      yield put({
        type: "LEDGER_HISTORY",
        id: id
      });
    } else {
      yield put({
        type: "LEDGER_UPDATE_FAILED",
        message: data?.message || "Failed to update ledger !!"
      });
    }
  } catch (error) {
    yield put({
      type: "LEDGER_UPDATE_FAILED",
      message: error?.response?.data?.message || "Failed to update ledger !!"
    });
  }
}

function* ledgerHistoryTable(action) {
  const { id } = action;

  try {
    const data = yield bearerReq("GET", `${agentApiPath}/getLedger/${id}`);

    yield put({
      type: "LEDGER_HISTORY_SUCCESS",
      data: data.data
    });
  } catch (error) {
    yield put({
      type: "LEDGER_HISTORY_FAILED",
      message: "Failed to get Ledger Data !!"
    });
  }
}

export default function* ledger() {
  yield takeEvery("LEDGER_CREATE", ledgerFunc);
  yield takeEvery("LEDGER_UPDATE", ledgerUpdateFunc);
  yield takeEvery("LEDGER_HISTORY", ledgerHistoryTable);
}
